export default {
  ADD_TO_CART: 'ADD_TO_CART',
  REMOVE_FROM_CART: 'REMOVE_FROM_CART',
  RENOVATION_BLACKFRIDAY: 'RENOVATION_BLACKFRIDAY',
  RENOVATION_CAMPAIGN: {
    NAVIDAD_2018: 'RENOVATION_CAMPAIGN_NAVIDAD_2018',
  },
  DIRECT_BUY: 'direct_buy',
  POPUPS: {
    OPEN_SHOPPING_CART: 'shopping_cart_popup_open',
    REMOVE_PACK: 'remove_pack_from_shopping_cart',
    REMOVE_COURSE: 'remove_course_from_shopping_cart',
    TO_SHOPPING_CART: 'to_shopping_cart_from_popup',
    TO_CHECKOUT: 'to_checkout_from_popup',
  },
  COURSE_PREVIEW: {
    CLOSE: 'course_preview_close',
    OPEN: 'course_preview_open',
  },
  COURSE_DETAIL: {
    BUY_NOW: 'course_detail_buy_now_button',
    ADD_TO_CART: 'course_detail_add_to_cart_button',
    REMOVE_FROM_CART: 'course_detail_remove_from_button',
    TOGGLE_STICKY_HEADER: 'course_detail_toggle_sticky_header',
    SHOW_MODULES: 'course_detail_show_modules',
    OPEN_GITFCARD_MODAL: 'course_detail_open_giftcard_modal',
    SEND_GIFTCARD: 'course_detail_send_giftcard',
    OPEN_FAQ_QUESTIONS: 'course_detail_open_faq_questions',
    PLAY_LIVE_VIDEO: 'course_detail_play_live_video',
    GO_PROFESSOR_PROFILE: 'course_detail_go_professor_profile',
    SHARE: 'COURSE_DETAIL_SHARE',
  },
  BUNDLE_HOME: {
    FILTER: 'bundle_home_filter_bundles_by',
  },
  BUNDLE_DETAIL: {
    BUY_NOW: 'bundle_detail_buy_now_button',
    ADD_TO_CART: 'bundle_detail_add_to_cart_button',
    REMOVE_FROM_CART: 'bundle_detail_remove_from_button',
    SEND_AS_GIFT: 'BUNDLE_DETAIL__SEND_AS_GIFT',
  },
  PAGE_READY: 'page_ready',
  LESSONS: {
    SHARED_FACEBOOK: 'shared_facebook',
    SHARED_TWITTER: 'shared_twitter',
    SHARED_LINKEDIN: 'shared_linkedin',
    DOWNLOAD_FILES: 'download_course_files',
    DOWNLOAD_MODULE_FILES: 'download_module_files',
    START_TOUR: 'welcome_guide_start',
    WELCOME_GUIDE: 'welcome_guide',
    FIRST_PLAY: 'first_click',
    CALLTOACTION_SIDEBAR: 'call_to_action_sidebar',
    CALLTOACTION_MODAL: 'call_to_action_modal',
    CALLTOACTION_HEADER: 'call_to_action_header',
    REPORT_PROBLEM: 'report_problem_lessons',
    CHANGE_PLAYER: 'change_videoplayer',
    CONTINUE: 'LESSONS_CONTINUE',
    GO_TO_LESSONS: 'LESSONS__GO_TO_LESSONS',
  },
  PRECHECKOUT: {
    PAGE_LOADED: 'precheckout_page_loaded',
  },
  JOBS: {
    GO_TO_JOBS: 'JOBS_go_to_jobs',
    GO_TO_SPECIFIC_JOB: 'JOBS_go_to_specific_job',
  },
  WEBINAR: {
    HOME_PAGE_LOADED: 'webinars_home_page_loaded',
    DETAILS_PAGE_LOADED: 'webinars_details_page_loaded',
  },
  LANDINGS: {
    SHARE_FACEBOOK: 'LANDINGS_share_facebook',
    SHARE_TWITTER: 'LANDINGS_share_twitter',
    SHARE_LINKEDIN: 'LANDINGS_share_linkedin',
    ADD_TO_CART: 'LANDINGS_add_to_cart',
    REMOVE_FROM_CART: 'LANDINGS_remove_from_cart',
    SHOW_PREVIEW: 'LANDINGS_show_preview',
    SELECT_FILTER: 'LANDINGS__SELECT_FILTER',
    CHANGE_PAGINATION: 'LANDINGS__CHANGE_PAGINATION',
    SEARCH_COURSES: 'LANDINGS__SEARCH_COURSES',
    SHOW_MORE: 'LANDINGS__SHOW_MORE',
  },
  DONTLEAVE: {
    DONTLEAVE_OPEN: 'dontleave_open',
    DONTLEAVE_REGISTER: 'dontleave_popup_register',
    DONTLEAVE_REGISTER_FACEBOOK: 'dontleave_popup_register_facebook',
    DONTLEAVE_REGISTER_GMAIL: 'dontleave_popup_register_gmail',
    DONTLEAVE_LOGIN: 'dontleave_dialog_login',
    SWITCH_TO_SOCIAL_NETWORKS: 'DONTLEAVE__SWITCH_TO_SOCIAL_NETWORKS',
    SWITCH_TO_EMAIL_AND_PASS: 'DONTLEAVE__SWITCH_TO_EMAIL_AND_PASS',
  },
  USER_DASHBOARD: {
    HOME_GO_TO_LAST_CLASS: 'user_dashboard_home_go_to_last_class',
    HOME_DOWNLOAD_RESOURCE: 'user_dashboard_home_download_resource',
    HOME_COMMENT_COURSE: 'user_dashboard_home_comment_course',
    HOME_RATING_COURSE: 'user_dashboard_home_rating_course',
    HOME_GO_TO_COURSE: 'user_dashboard_home_go_to_course',
    HOME_GO_TO_COURSE_RECOMMENDED:
      'user_dashboard_home_go_to_course_recommended',
    RATING_COURSE: 'user_dashboard_rating_course',
    CERTIFICATION_GO_TO_LAST_CLASS:
      'user_dashboard_certification_go_to_last_class',
    COURSE_FREE_GO_TO_LAST_CLASS: 'user_dashboard_course_free_go_to_last_class',
    PROJECTS_GO_TO_PROJECT: 'user_dashboard_projects_go_to_project',
    PROJECS_EDIT_PROJECT: 'user_dashboard_projetcs_edit_project',
    CERTIFICATE_DOWNLOAD: 'user_dashboard_certificate_download',
    TEACH_GO_TO_EDIT: 'user_dashboard_go_to_edit',
    TEACH_GO_TO_PUBLISH: 'user_dashboard_go_to_publish',
    START_ONBOARDING: 'user_dashboard_onboarding_start',
    IGNORE_ONBOARDING: 'user_dashboard_onboarding_ignore',
    COMPLETE_ONBOARDING: 'user_dashboard_onboarding_complete',
    OPEN_MY_NOTES: 'USER_DASHBOARD__OPEN_MY_NOTES',
  },
  CLASSNOTE: {
    EDIT: 'CLASSNOTE__EDIT',
    DELETE: 'CLASSNOTE__DELETE',
  },
  USER_PROFILE: {
    FOLLOW_USER: 'user_profile_follow_user',
    UNFOLLOW_USER: 'user_profile_unfollow_user',
    EDIT_PROFILE: 'user_profile_edit_profile',
    CHANGE_PROFILE_PICTURE: 'user_profile_change_profile_picture',
    GO_TO_SOCIAL_NETWORK: 'user_profile_go_to_social_network',
    PUBLISH_PROJECT: 'user_professor_publish_project',
    SEE_COURSE: 'user_profile_see_course',
    SEE_PROJECT: 'user_profile_see_project',
    SEE_SKILL: 'user_profile_see_skill',
    SEE_CATALOG: 'user_profile_see_catalog',
    SUBSCRIBE_NOW: 'user_profile_subscribe_now',
    SEE_PANEL: 'user_profile_see_panel',
    SEE_COURSE_I_TEACH: 'user_profile_see_course_i_teach',
    SEE_COURSE_CERTIFICATION: 'user_profile_see_course_certificacion',
    ADD_SKILLS: 'user_profile_add_skills',
  },
  USER_SETTINGS: {
    UPDATE_PROFILE: 'settings_profile_update_profile',
    CANCEL_SUBSCRIPTION: 'settings_profile_cancel_subscription',
    INVOICE_DOWNLOAD: 'settings_invoice_download',
  },
  CHECKOUT_2: 'checkout_2',
  CHECKOUT_3: 'checkout_3',
  SHOPPING_CART: {
    ADD_ITEM: 'shopping_cart_add_item',
    REMOVE_ITEM: 'shopping_cart_remove_item',
    GO_BACK_CATALOG: 'shopping_cart_go_back_catalog',
    BUY_NOW: 'shopping_cart_buy_now',
    VISIT_COURSE: 'shopping_cart_visit_course',
  },
  RESOURCE_LANDING: {
    SEE_RESOURCE: 'resource_landing_see_resource',
    SEE_WEBINAR: 'resource_landing_see_webinar',
    SEE_TUTORIAL: 'resource_landing_see_tutorial',
    SEE_EBOOK: 'resource_landing_see_ebook',
    FILTER_BY_RESOUCES: 'resource_landing_filter_by_resources',
    FILTER_BY_WEBINAR: 'resource_landing_filter_by_webinars',
    FILTER_BY_TUTORIAL: 'resource_landing_filter_by_tutorials',
    FILTER_BY_EBOOK: 'resource_landing_filter_by_ebooks',
    ORDER_BY_ALL: 'resource_landing_order_by_all',
    ORDER_BY_NEWEST: 'resource_landing_order_by_newest',
    ORDER_BY_OLDEST: 'resource_landing_order_by_oldest',
    ORDER_BY_LIKES: 'resource_landing_order_by_likes',
    SHARE_BANNER_WITH_FACEBOOK: 'resource_landing_share_banner_with_facebook',
    SHARE_BANNER_WITH_TWITTER: 'resource_landing_share_banner_with_twitter',
    SHARE_BANNER_WITH_LINKEDIN: 'resource_landing_share_banner_with_linkedin',
    REGISTER_USER: 'RESOURCE__REGISTER_USER',
  },
  RESOURCES: {
    SHARE: 'RESOURCES__SHARE',
    LIKE: 'RESOURCES__LIKE',
    DOWNLOAD: 'RESOURCES__DOWNLOAD',
    RESOURCE_DETAIL: 'detalle_de_recurso',
    EBOOK_DETAIL: 'detalle_de_ebook',
    WEBINAR_DETAIL: 'detalle_de_webinar',
    TUTORIAL_DETAIL: 'detalle_de_tutorial',
  },
  CAREER_DETAIL: {
    ENROLLMENT: 'career_detail_enrollment_button',
    BLOCKED_MODAL: 'career-_detail_blocked_modal',
  },
  MEMBERSHIP: {
    REGISTER_FROM_CTA: 'MEMBERSHIP_register_from_cta',
    CONTACT_FROM_FAQ: 'MEMBERSHIP_contact_from_faq',
    CHECK_BENEFITS_BUTTON: 'MEMBERSHIP_check_benefits_button',
    CHECKOUT_FROM_MAIN_BUTTON: 'MEMBERSHIP_checkout_from_main_button',
    CHECKOUT_FROM_MEMBERSHIP_CARD_BUTTON:
      'MEMBERSHIP_checkout_from_membership_card_button',
    CHECKOUT_FROM_TABLE_BUTTON: 'MEMBERSHIP_checkout_from_table_button',
    GO_TO_MEMBERSHIP: 'MEMBERSHIP__GO_TO_MEMBERSHIP',
    CANCEL_FROM_CONFIGURATION: 'MEMBERSHIP__CANCEL_FROM_CONFIGURATION',
    STAY_FROM_CONFIGURATION: 'MEMBERSHIP__STAY_FROM_CONFIGURATION',
    RENOVATE_FROM_POLL: 'MEMBERSHIP__RENOVATE_FROM_POLL',
  },
  MEMBERSHIP_RENOVATE: 'membership_renovate',
  MEMBERSHIP_UPGRADE: 'membership_upgrade',
  MEMBERSHIP_CANCELATION: {
    CANCELATION_OPCIONS: 'membership_cancelation_options',
    CANCEL_ANYWAY: 'membership_cancel_anyway',
    KEEP_LEARNING: 'membership_keep_learning',
    REACTIVATE: 'membership_reactivate',
    OPEN_DIALOG_TO_REACTIVATE: 'membership_reactivate_open_dialog',
  },
  PROJECT_LANDING: {
    SELECT_PROJECT: 'project_landing_select_project',
    SELECT_CATEGORY: 'project_landing_select_category',
    SELECT_FILTER: 'project_landing_select_filter',
  },
  LIVE_STREAMING: {
    REGISTER: 'LIVE_STREAMING_register',
    GET_MEMBERSHIP_FROM_VIDEO: 'LIVE_STREAMING_get_membership_from_video',
    GET_MEMBERSHIP_FROM_INFO: 'LIVE_STREAMING_get_membership_from_info',
    START_COURSE: 'LIVE_STREAMING_start_course',
    SEND_MESSAGE: 'LIVE_STREAMING_send_message',
    SHARE_TWITTER: 'LIVE_STREAMING_share_twitter',
    SHARE_FACEBOOK: 'LIVE_STREAMING_share_facebook',
    BUY_ENDED_COURSE: 'LIVE_STREAMING_buy_ended_course',
    SUBSCRIBE_TO_WAITINGLIST: 'LIVE_STREAMING__SUBSCRIBE_TO_WAITINGLIST',
  },
  SHOPPING_CART_MODAL: {
    OPEN_POPUP: 'SHOPPING_CART_MODAL_OPEN_POPUP',
    CLOSE_POPUP: 'SHOPPING_CART_MODAL_CLOSE_POPUP',
    KEEP_BUYING: 'SHOPPING_CART_MODAL_KEEP_BUYING',
    BUY_NOW: 'SHOPPING_CART_MODAL_BUY_NOW',
    GO_CART: 'SHOPPING_CART_MODAL_GO_CART',
    ADD_TO_CART: 'SHOPPING_CART_MODAL_ADD_TO_CART',
    GO_TO_DETAIL: 'SHOPPING_CART_MODAL_GO_TO_COURSEDETAIL',
  },
  MAIN_MENU: {
    PREMIUM: 'main_menu_premium_button',
    LOGIN: 'main_menu_login_button',
    REGISTER: 'main_menu_register_button',
    LOGIN_MOBILE: 'main_menu_login_button_mobile',
    REGISTER_MOBILE: 'main_menu_register_button_mobile',
    MAIN_MENU_LINK: 'main_menu_link',
  },
  MEMBERSHIP_ONBOARDING: {
    START: 'membership_onboarding_start',
    STEP0: 'membership_onboarding_welcome',
    STEP1_SELECT_GOAL: 'membership_onboarding_step1_select_goal',
    STEP1_PLUS: 'membership_onboarding_step1_plus',
    STEP2: 'membership_onboarding_step2',
    STEP2_SELECT_SUBCATEGORY: 'membership_onboarding_select_subcategory',
    STEP3_SELECT_INTEREST: 'membership_onboarding_select_interest',
    FINISH: 'membership_onboarding_finish',
    GO_TO_COURSE: 'membership_onboarding_go_to_course',
    GO_TO_CAREER: 'membership_onboarding_go_to_career',
    GO_TO_PACK: 'membership_onboarding_go_to_pack',
    GO_TO_CATALOG: 'membership_onboarding_go_to_catalog',
  },
  MENTORS: {
    CREATE_MENTOR_INBOX: 'MENTORS_create_mentor_inbox',
  },
  INBOX: {
    SELECT_INBOX: 'INBOX_select_inbox',
    SEND_MESSAGE: 'INBOX_send_message',
  },
  TOPBANNER: {
    CLICKCTA: 'topbanner_clickcta',
    CLICKCLOSE: 'topbanner_closebutton',
  },
  PERKS: {
    CLICKCTA: 'student_perks_clickcta',
    MODALCTA: 'student_perks_modalcta',
  },
  WISHLIST: {
    ADD_ITEM: 'WISHLIST__ADD_ITEM',
    REMOVE_ITEM: 'WISHLIST__REMOVE_ITEM',
  },
  LIVES: {
    ENROLL: 'LIVES__LIVE_ENROLLMENT',
    ATTEMPT_TO_LIVE_ENROLL: 'LIVES__ATTEMPT_TO_LIVE_ENROLL',
    GO_TO_OLD_LIVE: 'LIVES__GO_TO_OLD_LIVE',
    SEND_CHAT_MESSAGE: 'LIVES__SEND_CHAT_MESSAGE',
    ADD_TO_CALENDAR: 'LIVES__ADD_TO_CALENDAR',
    SHOW_IN_DIALOG: 'LIVES__SHOW_IN_DIALOG',
    GO_TO_STREAMING: 'LIVES__GO_TO_STREAMING',
    BUY_PRE_SALE_COURSE_FROM_FOOTER: 'LIVES__BUY_PRE_SALE_COURSE_FROM_FOOTER',
    BUY_PRE_SALE_COURSE_FROM_INFO_VIEW:
      'LIVES__BUY_PRE_SALE_COURSE_FROM_INFO_VIEW',
  },
  AUTH: {
    REGISTER: 'AUTH__REGISTER',
    LOGIN: 'AUTH__LOGIN',
    SHOW_MODAL_REGISTER: 'AUTH__SHOW_MODAL_REGISTER',
    SHOW_MODAL_LOGIN: 'AUTH__SHOW_MODAL_LOGIN',
  },
  COURSE: {
    GO_TO_COURSE_DETAIL: 'COURSE__GO_TO_COURSE_DETAIL',
    ENROLL: 'COURSE__ENROLL',
  },
  SHARE_PAGE: {
    FACEBOK: 'SHARE_PAGE___FACEBOOK',
    TWITTER: 'SHARE_PAGE___TWITTER',
  },
  CUSTOM_BUNDLE: {
    SELECT_FILTER: 'CUSTOM_BUNDLE__SELECT_FILTER',
    CHANGE_PAGINATION: 'CUSTOM_BUNDLE__CHANGE_PAGINATION',
    ADD_COURSE: 'CUSTOM_BUNDLE__ADD_COURSE',
    REMOVE_COURSE: 'CUSTOM_BUNDLE__REMOVE_COURSE',
    BUY_NOW: 'CUSTOM_BUNDLE__BUY_NOW',
    SEARCH_COURSES: 'CUSTOM_BUNDLE__SEARCH_COURSES',
    SHOW_MORE: 'CUSTOM_BUNDLE__SHOW_MORE',
    RECOMMENDED_COURSES: 'CUSTOM_BUNDLE_RECOMMENDED_COURSES',
  },
  DOWNLOAD_APPS: {
    APP_STORE: 'DOWNLOAD_APPS__APP_STORE',
    PLAY_STORE: 'DOWNLOAD_APPS__PLAY_STORE',
  },
  CERTIFICATES_LANDING: {
    SEARCH_CERTIFICATE: 'CERTIFICATES_LANDING__SEARCH_CERTIFICATE',
    DOWNLOAD_CERTIFICATE: 'CERTIFICATES_LANDING__DOWNLOAD_CERTIFICATE',
    VIEW_ALL: 'CERTIFICATES_LANDING__VIEW_ALL',
    COPY_LINK: 'CERTIFICATES_LANDING__COPY_LINK',
    SHARE: {
      FACEBOOK: 'CERTIFICATES_LANDING__SHARE_FACEBOOK',
      TWITTER: 'CERTIFICATES_LANDING__SHARE_TWITTER',
      LINKEDIN: 'CERTIFICATES_LANDING__SHARE_LINKEDIN',
      EMAIL: 'CERTIFICATES_LANDING__SHARE_EMAIL',
    },
  },
  MEMBERSHIP_RENOVATION_DIALOG: {
    SHOW: 'MEMBERSHIP_RENOVATION_DIALOG__SHOW',
    DISMISS: 'MEMBERSHIP_RENOVATION_DIALOG__DISMISS',
    ANSWER: 'MEMBERSHIP_RENOVATION_DIALOG__ANSWER',
    NOT_NOW: 'MEMBERSHIP_RENOVATION_DIALOG__NOT_NOW',
  },
  HOME_USER_B2B: {
    IGNORE_TOUR: 'HOME_USER_B2B_TOUR_IGNORE',
    COMPLETE_TOUR: 'HOME_USER_B2B_TOUR_COMPLETE',
  },
  WELCOME_FLUX: {
    NEXT_STEP: 'WELCOME_FLUX__NEXT_STEP',
    CHECK_MORE_COURSES: 'WELCOME_FLUX__CHECK_MORE_COURSES',
    SELECT_SUBCATEGORY: 'WELCOME_FLUX__SELECT_SUBCATEGORY',
    WATCH_PREVIEW: 'WELCOME_FLUX__WATCH_PREVIEW',
    GO_TO_HOME: 'WELCOME_FLUX__GO_TO_HOME',
    POST: {
      CHECK_MORE_POST: 'WELCOME_FLUX__CHECK_MORE_POST',
      CLICK_POST_TITLE: 'WELCOME_FLUX_CLICK_POST_TITLE',
      CLICK_POST_IMG: 'WELCOME_FLUX_CLICK_POST_IMG',
      CLICK_POST_CATEGORY: 'WELCOME_FLUX_CLICK_POST_CATEGORY',
    },
  },
  HOME_USER: {
    GO_TO_PROMO_FROM_BANNER: 'HOME_USER__GO_TO_PROMO_FROM_BANNER',
    GO_TO_RESOURCE: 'HOME_USER__GO_TO_RESOURCE',
    DOWNLOAD_RESOURCE: 'HOME_USER__DOWNLOAD_RESOURCE',
    GO_TO_COURSE_DETAIL: 'HOME_USER__GO_TO_COURSE_DETAIL',
    GO_TO_COURSE_DETAIL_ML: 'HOME_USER__GO_TO_COURSE_DETAIL_ML',
    GO_TO_LIVE_DETAIL: 'HOME_USER__GO_TO_LIVE_DETAIL',
    GO_TO_BLOG_DETAIL: 'HOME_USER__GO_TO_BLOG_DETAIL',
    EDIT_TASTES: 'HOME_USER__EDIT_TASTES',
    SELECT_FIRST_TIME_TASTES: 'HOME_USER__SELECT_FIRST_TIME_TASTES',
    ENROLL_IN_FREE_COURSE: 'HOME_USER__ENROLL_IN_FREE_COURSE',
  },
  PRELANDINGS: {
    SUBSCRIBE_BUTTON: 'PRELANDINGS_SUBSCRIBE_BUTTON',
  },
  CHECKOUT: {
    EXIT_POPUP: 'EXIT_POPUP',
    ROOT: 'CHECKOUT',
    PAYMENT: 'PAYMENT',
    ANONYMOUS_USER: 'GUEST_USER',
    LOGGED_USER: 'LOGGED_USER',
    BUY: 'CHECKOUT__BUY',
    BUY_DIRECT: 'CHECKOUT_BUY_DIRECT',
    PAYMENT_WITH_COINS: 'CHECKOUT_PAYMENT_WITH_COINS',
    FAILED_PAYMENT_POPUP: 'FAILED_PAYMENT_POPUP',
    FAILED_PAYMENT_POPUP_METHOD: 'FAILED_PAYMENT_POPUP_METHOD',
    PAY_WITH_STRIPE: 'CHECKOUT_PAY_WITH_STRIPE',
    PAY_WITH_STRIPE_FAILED: 'CHECKOUT_PAY_WITH_STRIPE_FAILED',
    PAY_WITH_STRIPE_MEXICO: 'CHECKOUT_PAY_WITH_STRIPE_MEXICO',
    PAY_WITH_CONEKTA: 'CHECKOUT_PAY_WITH_STRIPE_MEXICO',
    PAY_WITH_EBANX_CARD: 'PAY_WITH_EBANX_CARD',
    PAY_WITH_STRIPE_MEXICO_FAILED: 'CHECKOUT_PAY_WITH_STRIPE_MEXICO_FAILED',
    PAY_WITH_EPAYCO: 'CHECKOUT_PAY_WITH_EPAYCO',
    PAY_WITH_EPAYCO_FAILED: 'CHECKOUT_PAY_WITH_EPAYCO_FAILED',
    PAY_WITH_COMPROPAGO: 'CHECKOUT_PAY_WITH_COMPROPAGO',
    PAY_WITH_COMPROPAGO_FAILED: 'CHECKOUT_PAY_WITH_COMPROPAGO_FAILED',
    PAY_WITH_PAYPAL: 'CHECKOUT_PAY_WITH_PAYPAL',
    PAY_WITH_PAYPAL_FAILED: 'CHECKOUT_PAY_WITH_PAYPAL_FAILED',
    PAY_WITH_PAGO_EFECTIVO: 'CHECKOUT_PAY_WITH_PAGO_EFECTIVO',
    PAY_WITH_PAGO_EFECTIVO_FAILED: 'CHECKOUT_PAY_WITH_PAGO_EFECTIVO_FAILED',
    INCENTIVE_FOR_CARD_PAYMENT: 'Incentive for card payment',
  },
  ONBOARDING: {
    START: 'ONBOARDING__START',
    SKIP: 'ONBOARDING__SKIP',
    COMPLETE: 'ONBOARDING__COMPLETE',
  },
  HOME: {
    REGISTER_FROM_CTA_BANNER: 'HOME_REGISTER_FROM_CTA_BANNER',
    REGISTER_FROM_CTA: 'HOME_REGISTER_FROM_CTA',
    GO_TO_CATEGORY: 'HOME_GO_TO_CATEGORY',
  },
  CREHANA_EVENTS: {
    REGISTER: 'CREHANA_EVENTS_REGISTER',
    GO_TO_DETAIL: 'CREHANA_EVENTS__GO_TO_DETAIL',
  },
  COURSE_COMPLETE_DIALOG: {
    UPLOAD_PROJECT: 'COURSE_COMPLETE_DIALOG_UPLOAD_PROJECT',
    NOT_NOW: 'COURSE_COMPLETE_DIALOG_NOT_NOW',
  },
  COINS: {
    EXPLORE_CATALOG: 'COINS_EXPLORE_CATALOG',
  },
  COURSE_CARD: {
    TEACHER_PROFILE: 'COURSE_CARD_TEACHER_PROFILE',
    BUY_NOW: 'course_card_buy_now',
    SHOW_PREVIEW: 'COURSE_CARD_SHOW_PREVIEW',
    BUY_NOW_PREVIEW: 'COURSE_CARD_BUY_NOW_PREVIEW',
  },
  PAYMENT_WITH_SAVED_CARD: {
    FROM_COURSE_DETAIL: 'FROM_COURSE_DETAIL',
    QUICK_PURCHASE: 'PAYMENT_WITH_SAVED_CARD_FROM_COURSE_DETAIL_QUICK_PURCHASE',
    PAYMENT_WITH_SAVED_CARD: 'PAYMENT_WITH_SAVED_CARD',
    CHANGE_PAYMENT_METHOD_AFTER_FAILED:
      'PAYMENT_WITH_SAVED_CARD_FROM_COURSE_DETAIL_CHANGE_PAYMENT_METHOD_AFTER_FAILED',
    PAY_WITH_OTHER_PAYMENTS_METHODS:
      'PAYMENT_WITH_SAVED_CARD_FROM_COURSE_DETAIL_PAY_WITH_OTHER_PAYMENTS_METHODS',
    FAILED: 'PAYMENT_WITH_SAVED_CARD_FROM_COURSE_DETAIL_FAILED',
    CANCEL: 'PAYMENT_WITH_SAVED_CARD_FROM_COURSE_CANCEL',
    GIFT: 'COURSE_DETAIL_GIFT',
    CART: 'COURSE_DETAIL_CART',
  },
  ON_AIR_LANDING: {
    ADD_TO_CALENDAR: 'ON_AIR_LANDING_ADD_TO_CALENDAR',
    SUBSCRIBE_TO: 'ON_AIR_LANDING_SUBSCRIBE_TO',
  },
  WORK_WITH_US: {
    POSTULATE_HERE: 'WORK_WITH_US_POSTULATE_HERE',
    POSTULATE_NOW: 'WORK_WITH_US_POSTULATE_NOW',
  },
  THANKS_PAGE: {
    START_NOW_LINK: 'thanks_page_start_now_link',
    MAIN_BUTTON: 'thanks_page_go_main_button',
    AUTH__REGISTER_FROM_THANKYOUPAGE: 'AUTH__REGISTER_FROM_THANKYOUPAGE',
    AUTH__LOGIN_FROM_THANKYOUPAGE: 'AUTH__LOGIN_FROM_THANKYOUPAGE',
  },
  PROJECT_DETAIL: {
    EDIT: 'PROJECT_DETAIL__EDIT',
    GO: 'PROJECT_DETAIL__GO',
  },
  TRANSMISSIONS: {
    LANDING_PREVIOUS: 'TRANSMISSIONS__LANDING_PREVIOUS',
    LANDING_UPCOMING: 'TRANSMISSIONS__LANDING_UPCOMING',
    DIALOG_UPCOMING_DETAIL: 'TRANSMISSIONS__DIALOG_UPCOMING_DETAIL',
    LANDING_PREVIOUS_TRANSMISSION_DETAIL:
      'TRANSMISSIONS__LANDING_PREVIOUS_TRANSMISSION_DETAIL',
    LANDING_LIVE: 'TRANSMISSIONS__LANDING_LIVE',
    ENROLL: 'TRANSMISSIONS__ENROLL',
    SUBSCRIBE_TO_PRESALE: 'TRANSMISSIONS__SUBSCRIBE_TO_PRESALE',
    SEND_CHAT_MESSAGE: 'TRANSMISSIONS__SEND_CHAT_MESSAGE',
    CHECK_LIVE_INFO: 'TRANSMISSION__CHECK_LIVE_INFO',
    CHECK_CHAT_MESSAGES: 'TRANSMISSION__CHECK_CHAT_MESSAGES',
    SEND_POLL: 'TRANSMISSIONS__SEND_POLL',
    /**
     * also, in server side, we have a creat_chat track.
     * it can be filter by user_type: membership | moderator | free to paid | free | paid | new
     */
  },
  SEO_LANDING: {
    VIEW_ALL_COURSES: 'SEO_LANDING__VIEW_ALL_COURSES',
    OPEN_POST: 'SEO_LANDING__OPEN_POST',
    GO_TO_BLOG: 'SEO_LANDING__GO_TO_BLOG',
    GO_SUBCATEGORY: 'SEO_LANDING__GO_SUBCATEGORY',
    GO_TEACHER_PROFILE: 'SEO_LANDING__GO_TEACHER_PROFILE',
  },
  USER_CONFIGURATION: {
    SUBSCRIPTION_LINK: 'user_configuration__subscription_link',
    PAYMENT_METHOD_LINK: 'user_configuration__payment_method_link',
    CANCEL_MEMBERSHIP: 'user_configuration__cancel_membership',
    REMOVE_PAYMENT_METHOD_DIALOG:
      'user_configuration__remove_payment_method_dialog',
    REMOVE_PAYMENT_METHOD: 'user_configuration__remove_payment_method',
    SHOW_CANCEL_SUBSCRIPTION_DIALOG:
      'user_configuration__show_cancel_subscription_dialog',
    CLICK_TO_CANCEL: 'click_to_cancel',
  },
};
